import React, { useState } from 'react';
import { ArrowLeftIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export function LovedOneAssessmentPage() {
  const [currentStep, setCurrentStep] = useState(1);
  const totalSteps = 5;
  const goToNextStep = () => {
    if (currentStep < totalSteps) {
      setCurrentStep(currentStep + 1);
    }
  };
  const goToPreviousStep = () => {
    if (currentStep > 1) {
      setCurrentStep(currentStep - 1);
    }
  };
  return <div className="w-full min-h-screen bg-[#f8f8f8] py-12 px-6" data-id="element-2567">
      <div className="max-w-4xl mx-auto" data-id="element-2568">
        {/* Back button */}
        <div className="mb-8" data-id="element-2569">
          <Link to="/assessment" className="flex items-center text-gray-600 hover:text-[#631bb7] transition-colors" data-id="element-2570">
            <ArrowLeftIcon size={20} className="mr-2" data-id="element-2571" />
            <span className="font-medium" data-id="element-2572">Back</span>
          </Link>
        </div>
        {/* Progress indicator */}
        <div className="mb-8" data-id="element-2573">
          <div className="flex justify-between items-center mb-2" data-id="element-2574">
            <span className="text-sm font-bold text-[#631bb7]" data-id="element-2575">
              Step {currentStep} of {totalSteps}
            </span>
            <span className="text-sm font-semibold text-gray-500" data-id="element-2576">
              {Math.round(currentStep / totalSteps * 100)}% Complete
            </span>
          </div>
          <div className="w-full bg-gray-200 rounded-full h-2" data-id="element-2577">
            <div className="bg-[#631bb7] h-2 rounded-full transition-all duration-300" style={{
            width: `${currentStep / totalSteps * 100}%`
          }} data-id="element-2578"></div>
          </div>
        </div>
        {/* Assessment Content */}
        <div className="bg-white rounded-2xl p-8 border-2 border-gray-200" data-id="element-2579">
          {currentStep === 1 && <div data-id="element-2580">
              <h1 className="text-3xl md:text-4xl font-bold text-[#111111] mb-6" data-id="element-2581">
                Tell us about yourself
              </h1>
              <p className="text-gray-600 mb-8 leading-relaxed" data-id="element-2582">
                We'll customize your experience based on your needs.
              </p>
              <div className="space-y-6 mb-8" data-id="element-2583">
                <div className="border-2 border-gray-200 rounded-xl p-6" data-id="element-2584">
                  <h3 className="text-xl font-bold text-[#111111] mb-4" data-id="element-2585">
                    What's your relationship to your Guardian?
                  </h3>
                  <div className="space-y-3" data-id="element-2586">
                    <label className="flex items-center p-4 border-2 border-gray-200 rounded-lg cursor-pointer hover:border-[#631bb7] transition-colors" data-id="element-2587">
                      <input type="radio" name="relationship" className="mr-3 w-4 h-4 accent-[#631bb7]" data-id="element-2588" />
                      <span className="font-medium" data-id="element-2589">They're my parent</span>
                    </label>
                    <label className="flex items-center p-4 border-2 border-gray-200 rounded-lg cursor-pointer hover:border-[#631bb7] transition-colors" data-id="element-2590">
                      <input type="radio" name="relationship" className="mr-3 w-4 h-4 accent-[#631bb7]" data-id="element-2591" />
                      <span className="font-medium" data-id="element-2592">They're my sibling</span>
                    </label>
                    <label className="flex items-center p-4 border-2 border-gray-200 rounded-lg cursor-pointer hover:border-[#631bb7] transition-colors" data-id="element-2593">
                      <input type="radio" name="relationship" className="mr-3 w-4 h-4 accent-[#631bb7]" data-id="element-2594" />
                      <span className="font-medium" data-id="element-2595">Other family member</span>
                    </label>
                  </div>
                </div>
              </div>
              <div className="flex justify-end" data-id="element-2596">
                <button onClick={goToNextStep} className="bg-[#631bb7] text-white px-8 py-3 rounded-lg font-bold hover:bg-[#521099] transition-all shadow-md" data-id="element-2597">
                  Continue
                </button>
              </div>
            </div>}
          {currentStep > 1 && <div data-id="element-2598">
              <h1 className="text-3xl md:text-4xl font-bold text-[#111111] mb-6" data-id="element-2599">
                Assessment Step {currentStep}
              </h1>
              <p className="text-gray-600 mb-8 leading-relaxed" data-id="element-2600">
                This is a placeholder for step {currentStep} of the assessment.
              </p>
              <div className="flex justify-between" data-id="element-2601">
                <button onClick={goToPreviousStep} className="border-2 border-gray-300 text-[#111111] px-8 py-3 rounded-lg font-bold hover:border-[#631bb7] hover:text-[#631bb7] transition-colors" data-id="element-2602">
                  Back
                </button>
                <button onClick={goToNextStep} className="bg-[#631bb7] text-white px-8 py-3 rounded-lg font-bold hover:bg-[#521099] transition-all shadow-md" data-id="element-2603">
                  Continue
                </button>
              </div>
            </div>}
        </div>
      </div>
    </div>;
}